const TOGGLE_SELECTED = 'VENMO_TOGGLE_SELECTED';
const SET_READY = 'VENMO_SET_READY';
const SHOW_INLINE_ERROR = 'VENMO_SHOW_INLINE_ERROR';
const RESET_VENMO_ERROR = 'RESET_VENMO_ERROR';

export {
    TOGGLE_SELECTED, SET_READY, SHOW_INLINE_ERROR, RESET_VENMO_ERROR
};
